export function ObjectLength(object: {}) {
  var length = 0;
  for (var key in object) {
    if (object.hasOwnProperty(key)) {
      ++length;
    }
  }
  return length;
}

export function removeDuplicates(array: any[],key: string="id") {
  try {
    let newArray = [];

    let uniqueObject: any = {};
    for (let i in array) {
      const objTitle = array[i][key];

      // Use the id as the index
      uniqueObject[objTitle] = array[i];
    }

    for (let i in uniqueObject) {
      newArray.push(uniqueObject[i]);
    }


    return newArray;
  } catch (error) {
    return array;
  }

}
